import { Box, styled } from "@mui/material";
import FlexBox from "components/flexbox/FlexBox";
import FlexBetween from "components/flexbox/FlexBetween";
import Scrollbar from "components/ScrollBar";
import LayoutDrawer from "layouts/layout-parts/LayoutDrawer";
import MultiLevelMenu from "./MultiLevelMenu";

const TOP_HEADER_AREA = 70;

// Anchored to top/bottom of viewport so the drawer panel fills
// the full visible height even with the global `zoom` scaling.
const Container = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background.paper,
}));

const NavWrapper = styled(Box)(() => ({
  paddingLeft: 16,
  paddingRight: 16,
  height: "100%",
}));

const MobileSidebar = ({ showMobileSideBar, setShowMobileSideBar }) => {
  return (
    <LayoutDrawer open={showMobileSideBar} onClose={setShowMobileSideBar}>
      <Container>
        <FlexBetween
          pt={2}
          pr={3}
          pl={3}
          pb={1}
          minHeight={TOP_HEADER_AREA}
          sx={{ flexShrink: 0 }}
        >
          <FlexBox alignItems="center" gap={1}>
            <img
              src="/nextgen/nextgen_logo.png"
              alt="NextGen Logo"
              style={{ height: 40, maxWidth: 160, objectFit: "contain" }}
            />
          </FlexBox>
        </FlexBetween>

        <Scrollbar
          autoHide
          clickOnTrack={false}
          sx={{
            flex: 1,
            minHeight: 0,
            overflowX: "hidden",
          }}
        >
          <NavWrapper>
            <MultiLevelMenu sidebarCompact={false} />
          </NavWrapper>
        </Scrollbar>
      </Container>
    </LayoutDrawer>
  );
};

export default MobileSidebar;
